/**
 * Stablecoin alpha-2 country code shared by multiple modules
 * (transaction, contacts, movements, dashboard) and by shared/common
 * utilities. Promoted to shared so that shared/common does not import
 * from `@/modules/*`.
 */
export const STABLECOIN_COUNTRY_CODE = 'XS';

export const EXCLUDE_STABLECOINS_REGEX = `(?!.*${STABLECOIN_COUNTRY_CODE}).*`;
